import { render } from "./EditableDatePicker.vue?vue&type=template&id=08e701da"
import script from "./EditableDatePicker.vue?vue&type=script&lang=js"
export * from "./EditableDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__